import { render, staticRenderFns } from "./agreement.vue?vue&type=template&id=60599f4a&scoped=true&"
import script from "./agreement.vue?vue&type=script&lang=js&"
export * from "./agreement.vue?vue&type=script&lang=js&"
import style0 from "./agreement.vue?vue&type=style&index=0&id=60599f4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60599f4a",
  null
  
)

export default component.exports